<script>
import Editable from 'vue-xeditable/src/Editable';

export default {
  extends: Editable,
  data() {
    return {};
  },
  methods: {
    handleChange(value) {
      // this.value = value;
      this.$emit('change', value);
      this.$emit('input', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Editable.vue